import { render, staticRenderFns } from "./GridMembers.vue?vue&type=template&id=bc836216&scoped=true"
import script from "./GridMembers.vue?vue&type=script&lang=js"
export * from "./GridMembers.vue?vue&type=script&lang=js"
import style0 from "./GridMembers.vue?vue&type=style&index=0&id=bc836216&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc836216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc836216')) {
      api.createRecord('bc836216', component.options)
    } else {
      api.reload('bc836216', component.options)
    }
    module.hot.accept("./GridMembers.vue?vue&type=template&id=bc836216&scoped=true", function () {
      api.rerender('bc836216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Grid/GridMembers.vue"
export default component.exports